import GoogleReCaptcha from './Google/ReCaptcha';
import type { ReCAPTCHAToken, SiteKey } from './Google/ReCaptcha.d';

declare global {

    interface Window {
        grecaptcha: {
            ready: (callback: () => unknown) => unknown,
            execute: (siteKey: SiteKey, opts: { action: string }) => Promise<ReCAPTCHAToken>,
        },
        _siteConfig: {
            SITESMART_DEV: number,
            SITESMART_SITE_URL: string,
            SITESMART_FILES_URL: string,
            SITESMART_USER_LANGUAGE: string,
            loaderUrl: string,
            placeholderUrl: string,
            currencyFormat: string,
        };
    }
}

new GoogleReCaptcha().init();
